export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',xs:10,ms:10,block:{xs:10,ms:10}}}